/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlDirectoryUserGroupDTO } from './ControlDirectoryUserGroupDTO';
import {
    ControlDirectoryUserGroupDTOFromJSON,
    ControlDirectoryUserGroupDTOFromJSONTyped,
    ControlDirectoryUserGroupDTOToJSON,
} from './ControlDirectoryUserGroupDTO';
import type { ControlEmailDirection } from './ControlEmailDirection';
import {
    ControlEmailDirectionFromJSON,
    ControlEmailDirectionFromJSONTyped,
    ControlEmailDirectionToJSON,
} from './ControlEmailDirection';

/**
 * 
 * @export
 * @interface ControlDirectoryUser
 */
export interface ControlDirectoryUser {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlDirectoryUser
     */
    additionalEmails: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    administrator?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlDirectoryUser
     */
    allEmails: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    chatOpsOnboardingUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    containable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    contained?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    credentialsExposed: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    department?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    directoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    email?: string;
    /**
     * 
     * @type {ControlEmailDirection}
     * @memberof ControlDirectoryUser
     */
    emailDirection?: ControlEmailDirection;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    external?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    financial?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    groupChatOpsEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    groupContainmentEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    groupSourceSystemUpdates: boolean;
    /**
     * 
     * @type {Array<ControlDirectoryUserGroupDTO>}
     * @memberof ControlDirectoryUser
     */
    groups: Array<ControlDirectoryUserGroupDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    groupsSynced: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    id: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDirectoryUser
     */
    integrationId: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDirectoryUser
     */
    lastCheckedForCredentialExposures?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDirectoryUser
     */
    lastCredentialExposure?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    lastSignInAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    managed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    managerDirectoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    managerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    needsChatOpsWelcome?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    nhi?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUser
     */
    numberCredentialExposures: number;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    passwordLastChangedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    previousPhoneNumber?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDirectoryUser
     */
    raw?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlDirectoryUser
     */
    roles: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDirectoryUser
     */
    smsConsentReceivedAt?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof ControlDirectoryUser
     */
    smsInviteAttempts: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlDirectoryUser
     */
    smsInviteLastSentAt?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    smsInviteOptOut?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    teamId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    technical?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDirectoryUser
     */
    verifiedPhoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlDirectoryUser
     */
    vip?: boolean;
}

/**
 * Check if a given object implements the ControlDirectoryUser interface.
 */
export function instanceOfControlDirectoryUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "additionalEmails" in value;
    isInstance = isInstance && "allEmails" in value;
    isInstance = isInstance && "containable" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "credentialsExposed" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "groupChatOpsEnabled" in value;
    isInstance = isInstance && "groupContainmentEnabled" in value;
    isInstance = isInstance && "groupSourceSystemUpdates" in value;
    isInstance = isInstance && "groups" in value;
    isInstance = isInstance && "groupsSynced" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "integrationId" in value;
    isInstance = isInstance && "numberCredentialExposures" in value;
    isInstance = isInstance && "roles" in value;
    isInstance = isInstance && "smsInviteAttempts" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function ControlDirectoryUserFromJSON(json: any): ControlDirectoryUser {
    return ControlDirectoryUserFromJSONTyped(json, false);
}

export function ControlDirectoryUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDirectoryUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'additionalEmails': json['additionalEmails'],
        'administrator': !exists(json, 'administrator') ? undefined : json['administrator'],
        'allEmails': json['allEmails'],
        'chatOpsOnboardingUser': !exists(json, 'chatOpsOnboardingUser') ? undefined : json['chatOpsOnboardingUser'],
        'containable': json['containable'],
        'contained': !exists(json, 'contained') ? undefined : json['contained'],
        'createdAt': json['createdAt'],
        'credentialsExposed': json['credentialsExposed'],
        'department': !exists(json, 'department') ? undefined : json['department'],
        'directoryId': !exists(json, 'directoryId') ? undefined : json['directoryId'],
        'displayName': json['displayName'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'emailDirection': !exists(json, 'emailDirection') ? undefined : ControlEmailDirectionFromJSON(json['emailDirection']),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'external': !exists(json, 'external') ? undefined : json['external'],
        'financial': !exists(json, 'financial') ? undefined : json['financial'],
        'groupChatOpsEnabled': json['groupChatOpsEnabled'],
        'groupContainmentEnabled': json['groupContainmentEnabled'],
        'groupSourceSystemUpdates': json['groupSourceSystemUpdates'],
        'groups': ((json['groups'] as Array<any>).map(ControlDirectoryUserGroupDTOFromJSON)),
        'groupsSynced': json['groupsSynced'],
        'id': json['id'],
        'integrationId': json['integrationId'],
        'lastCheckedForCredentialExposures': !exists(json, 'lastCheckedForCredentialExposures') ? undefined : json['lastCheckedForCredentialExposures'],
        'lastCredentialExposure': !exists(json, 'lastCredentialExposure') ? undefined : json['lastCredentialExposure'],
        'lastSignInAt': !exists(json, 'lastSignInAt') ? undefined : json['lastSignInAt'],
        'managed': !exists(json, 'managed') ? undefined : json['managed'],
        'managerDirectoryId': !exists(json, 'managerDirectoryId') ? undefined : json['managerDirectoryId'],
        'managerEmail': !exists(json, 'managerEmail') ? undefined : json['managerEmail'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'needsChatOpsWelcome': !exists(json, 'needsChatOpsWelcome') ? undefined : json['needsChatOpsWelcome'],
        'nhi': !exists(json, 'nhi') ? undefined : json['nhi'],
        'numberCredentialExposures': json['numberCredentialExposures'],
        'passwordLastChangedAt': !exists(json, 'passwordLastChangedAt') ? undefined : json['passwordLastChangedAt'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'previousPhoneNumber': !exists(json, 'previousPhoneNumber') ? undefined : json['previousPhoneNumber'],
        'raw': !exists(json, 'raw') ? undefined : json['raw'],
        'roles': json['roles'],
        'smsConsentReceivedAt': !exists(json, 'smsConsentReceivedAt') ? undefined : json['smsConsentReceivedAt'],
        'smsInviteAttempts': json['smsInviteAttempts'],
        'smsInviteLastSentAt': !exists(json, 'smsInviteLastSentAt') ? undefined : json['smsInviteLastSentAt'],
        'smsInviteOptOut': !exists(json, 'smsInviteOptOut') ? undefined : json['smsInviteOptOut'],
        'teamId': json['teamId'],
        'technical': !exists(json, 'technical') ? undefined : json['technical'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'verifiedPhoneNumber': !exists(json, 'verifiedPhoneNumber') ? undefined : json['verifiedPhoneNumber'],
        'vip': !exists(json, 'vip') ? undefined : json['vip'],
    };
}

export function ControlDirectoryUserToJSON(value?: ControlDirectoryUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'additionalEmails': value.additionalEmails,
        'administrator': value.administrator,
        'allEmails': value.allEmails,
        'chatOpsOnboardingUser': value.chatOpsOnboardingUser,
        'containable': value.containable,
        'contained': value.contained,
        'createdAt': value.createdAt,
        'credentialsExposed': value.credentialsExposed,
        'department': value.department,
        'directoryId': value.directoryId,
        'displayName': value.displayName,
        'domain': value.domain,
        'email': value.email,
        'emailDirection': ControlEmailDirectionToJSON(value.emailDirection),
        'enabled': value.enabled,
        'external': value.external,
        'financial': value.financial,
        'groupChatOpsEnabled': value.groupChatOpsEnabled,
        'groupContainmentEnabled': value.groupContainmentEnabled,
        'groupSourceSystemUpdates': value.groupSourceSystemUpdates,
        'groups': ((value.groups as Array<any>).map(ControlDirectoryUserGroupDTOToJSON)),
        'groupsSynced': value.groupsSynced,
        'id': value.id,
        'integrationId': value.integrationId,
        'lastCheckedForCredentialExposures': value.lastCheckedForCredentialExposures,
        'lastCredentialExposure': value.lastCredentialExposure,
        'lastSignInAt': value.lastSignInAt,
        'managed': value.managed,
        'managerDirectoryId': value.managerDirectoryId,
        'managerEmail': value.managerEmail,
        'name': value.name,
        'needsChatOpsWelcome': value.needsChatOpsWelcome,
        'nhi': value.nhi,
        'numberCredentialExposures': value.numberCredentialExposures,
        'passwordLastChangedAt': value.passwordLastChangedAt,
        'phoneNumber': value.phoneNumber,
        'previousPhoneNumber': value.previousPhoneNumber,
        'raw': value.raw,
        'roles': value.roles,
        'smsConsentReceivedAt': value.smsConsentReceivedAt,
        'smsInviteAttempts': value.smsInviteAttempts,
        'smsInviteLastSentAt': value.smsInviteLastSentAt,
        'smsInviteOptOut': value.smsInviteOptOut,
        'teamId': value.teamId,
        'technical': value.technical,
        'title': value.title,
        'updatedAt': value.updatedAt,
        'username': value.username,
        'verifiedPhoneNumber': value.verifiedPhoneNumber,
        'vip': value.vip,
    };
}

